import { AuthenticatedLayout } from '@client/components/_core/layout/AuthenticatedLayout';
import { PageController } from '@client/components/_core/layout/PageController';
import { LiteRouteGuard } from '@client/components/_core/navigation/LiteRouteGuard';
import { RouteAccessGuard } from '@client/components/_core/navigation/RouteAccessGuard';
import { RequireAuth } from '@client/components/auth/RequireAuth';
import { ORG_SETTINGS_QUERY_OPTIONS } from '@client/trpc/query-options';
import type { ShareableRouteContext } from '@client/types/router';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Home } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId')({
    params: {
        parse({ orgId }) {
            return { orgId: BigInt(orgId) };
        },
    },
    beforeLoad: ({ context, params }): ShareableRouteContext => {
        // Warm org settings (logo URL etc.) while the route chunks parse, so the nav logo — the
        // LCP element on most authenticated pages — can start fetching on mount instead of waiting
        // on a render-time query in CurrentOrg. Fire-and-forget; render-time useQuery retries on miss.
        void context.trpcUtils.org.getOrgSettings.prefetch({ orgId: params.orgId }, { ...ORG_SETTINGS_QUERY_OPTIONS });
        return undefined;
    },
    staticData: {
        ui: {
            icon: Home,
        },
    },
    component: Console,
});

function Console() {
    return (
        <PageController route={Route}>
            <RequireAuth>
                <AuthenticatedLayout>
                    <RouteAccessGuard>
                        <LiteRouteGuard>
                            <Outlet />
                        </LiteRouteGuard>
                    </RouteAccessGuard>
                </AuthenticatedLayout>
            </RequireAuth>
        </PageController>
    );
}
